<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre" id="pgepubid00002"><span class="calibre1" id="Page_31" title="31"></span><span>Afternoon Session</span></h2>
<p class="pindent">MARSHAL (Colonel Charles W. Mays): May it please the Court:
I desire to announce that the Defendant Streicher will be absent on
account of illness.</p>
<p class="pindent">MR. COUNSELLOR SHENIN: I shall read now excerpts from the
note of the People’s Commissar. . .</p>
<p class="pindent">[<span class="it1">The proceedings were interrupted by technical difficulties in the
interpreting system.</span>]</p>
<p class="pindent">THE PRESIDENT: The Tribunal will adjourn.</p>
<p class="line13">[<span class="it1">A recess was taken.</span>]</p>
<p class="pindent">THE PRESIDENT: Owing to the delay the Tribunal will sit until
half past 5 tonight without further adjournment.</p>
<p class="pindent">Yes, Colonel.</p>
<p class="pindent">MR. COUNSELLOR SHENIN: I am reading into the record
excerpts from the note by the People’s Commissar for Foreign
Affairs dated 27 April 1942, and in order to save time I shall, with
your permission, quote only a few of the most necessary excerpts
from this note. They are very short. In this note, attention was
drawn to the fact that the documents captured by the Soviet authorities
and put at the disposal of the People’s Commissar for Foreign
Affairs are evidence of the premeditated nature of the plunder
carried out by the Hitlerites.</p>
<p class="pindent">I read the following excerpts; last paragraph on Page 44 of my
statement, Russian text.</p>
<div class="blockquote">
<p class="calibre3">“The appendix to Special Order Number 43761/41 of the Operations
Department of the General Staff of the German Army,
states:</p>
<p class="calibre3">“ ‘It is urgently necessary that articles of clothing be acquired
by means of forced levies on the population of the occupied
regions enforced by every possible means. It is necessary
above all to confiscate woolen and leather gloves, coats, vests,
and scarves, padded vests and trousers, leather and felt boots,
and puttees.’</p>
<p class="calibre3">“In several places liberated in the districts of Kursk and Orel,
the following orders have been found:</p>
<p class="calibre3">“ ‘Property such as scales, sacks, grain, salt, kerosene, benzine,
lamps, pots and pans, oilcloth, window blinds, curtains,
rugs, phonographs, and records must be turned in to the commandant’s
office. Anyone violating this order will be shot.’
<span id="Page_32" title="32"></span></p>
<p class="calibre3">“In the town of Istra, in the Moscow region, the invaders
confiscated decorations for Christmas trees and toys. In the
Shakhovskaya railway station they organized the ‘delivery’
by the inhabitants of children’s underwear, wall clocks, and
samovars. In districts still under the rule of the invaders,
these searches are still going on; and the population, already
reduced to the utmost poverty by the thefts which have been
perpetrated continually since the first appearance of the German
troops, is still being robbed.”</p>
</div>
<p class="pindent">I omit the rest of the quotation from Mr. Molotov’s note and
conclude with the last paragraph:</p>
<div class="blockquote">
<p class="calibre3">“The general character of the campaign of robbery planned
by the Hitler Government, on which the German Command
tried to base its plans for supplying its Army and the districts
in its rear, is indicated by the following facts: In 25 districts
of the Tula region alone the invaders robbed Soviet citizens of
14,048 cows, 11,860 hogs, 28,459 sheep, 213,678 chickens, geese,
and ducks, and destroyed 25,465 beehives.”</p>
</div>
<p class="pindent">I omit the remainder of this quotation which gives an inventory
of all property, cattle, and fowl confiscated by the invaders from
25 districts of the Tula region.</p>
<p class="pindent">Your Honors, the notes which I have read, mention only a few
of the innumerable crimes and cases of plunder committed by the
Hitlerites on Soviet soil.</p>
<p class="pindent">With the permission of the Tribunal I shall now present several
German documents from which you will see how the German commanders
and officials themselves described their soldiers’ behavior.
Later I shall read candid statements by the German fascist leaders
saying that German soldiers and officers must not be hindered in
their marauding activities. It is natural that under these conditions
the moral disintegration of the German fascist armies should reach
its culminating point. Things reached such a point that the Hitlerites
begin to plunder each other, thereby proving the truth of the well-known
Russian proverb, “A thief stole a cudgel from a thief.”</p>
<p class="pindent">May I now quote from the document which I present to the
Tribunal as Document Number USSR-285. This is an extract from
a report of the German District Commissioner of Zhitomir to the
Commissioner General of Zhitomir dated 30 November 1943. You
will find the document to which I refer on Page 93 in the document
book. I read:</p>
<div class="blockquote">
<p class="calibre3">“Even before the German administration left Zhitomir, troops
stationed there were seen to break into the apartments of
Reich Germans and to appropriate everything that had any
value. Even the personal luggage of Germans still working in
<span id="Page_33" title="33"></span>
their offices was stolen. When the town was reoccupied it
was established that the houses where the Germans lived
were hardly touched by the local population, but that the
troops just entering the town had already started to loot the
houses and business premises. . . .”</p>
</div>
<p class="pindent">I read the second excerpt from the same document:</p>
<div class="blockquote">
<p class="calibre3">“The soldiers are not satisfied with taking the articles they
can use, but they destroyed some of the remaining items;
valuable furniture was used for fires, although there was
plenty of wood.”</p>
</div>
<p class="pindent">Now I shall read into the record an excerpt from a report of
the German District Commissioner of the town of Korostyshev to
the Commissioner General of Zhitomir. The members of the Tribunal
will find this excerpt on Page 94 of the document book.</p>
<div class="blockquote">
<p class="calibre3">“Unfortunately the German soldiers behaved badly. Unlike
the Russians they broke into the storehouses even when the
front line was still far away. Enormous quantities of grain
were stolen, including large quantities of seed. That might
have been tolerated in the case of combat units. . . . Upon the
return of our troops to Popelnaya, the warehouses were again
broken into immediately. The ‘Gebiets- und Kreislandwirt’
nailed up the doors again, but the soldiers broke in once
more.”</p>
</div>
<p class="pindent">I read into the record other excerpts from the same document:</p>
<div class="blockquote">
<p class="calibre3">“The Kreislandwirt reported to me that the dairy farm was
plundered by retreating units; the soldiers carried away with
them butter, cheese, <span class="it1">et cetera</span>.”</p>
</div>
<p class="pindent">And the second excerpt:</p>
<div class="blockquote">
<p class="calibre3">“The co-operative store was plundered before the eyes of the
Ukrainians. Among other things the soldiers took with them
all the cash in the store.”</p>
</div>
<p class="pindent">Then the third excerpt:</p>
<div class="blockquote">
<p class="calibre3">“On the 9th and 10th of this month the guards of the field
gendarmerie were posted at the co-operative store in Korostyshev.
These guards could not repel the onslaught of the
soldiers. . . .”</p>
</div>
<p class="pindent">And the last excerpt:</p>
<div class="blockquote">
<p class="calibre3">“Pigs and fowls were slaughtered to the most irresponsible
degree and taken away by the soldiers. . . . The appearance of
the troops themselves can only be described as catastrophic.”</p>
</div>
<p class="pindent">In these towns; Your Honors, is the conduct of the German
soldiers depicted by a German commissioner in his official report.
<span id="Page_34" title="34"></span></p>
<p class="pindent">There is no doubt that this description is an objective one,
especially since it is supplemented by an official report of the
German Ukrainian company for supplying agriculture in the Commissariat
General, addressed to the Commissioner General of
Zhitomir. This is how the report describes the results of a raid by
German soldiers on the company’s premises, “. . . The office was in
a horrifying and incredible condition.” Second excerpt:</p>
<div class="blockquote">
<p class="calibre3">“. . . A 20-room private house at Hauptstrasse Number 57
had an appalling appearance. Carpets and stair carpets were
missing, and all the upholstered armchairs, couches, beds with
spring or other mattresses, chairs, and wooden benches.”</p>
</div>
<p class="line12">I skip a few lines:</p>
<div class="blockquote">
<p class="calibre3">“The condition of the living rooms generally is almost indescribable.”</p>
</div>
<p class="line12">I omit two more excerpts from the document.</p>
<p class="pindent">Such, Your Honors, is the heartcry of the German brigands of
the company for the economic adoption of the Ukraine, who themselves
complain of the brigands in the German Army.</p>
<p class="pindent">In order to show that it was not only in Zhitomir and Korostyshev
that such things took place, I shall quote yet another report, this
time by the Commissioner of the Kazatinsky district, which contains
the following statement, “. . . The German soldiers stole food,
cattle, and vehicles.” This laconic but significant introduction is
followed by no less significant details:</p>
<div class="blockquote">
<p class="calibre3">“Threatening him with a pistol, the corporal demanded the
keys of the granary from the District Commissioner. . . .
When I said that the key was in my pocket, he yelled, ‘Give
me the key.’ With these words he pulled out his pistol, stuck
it against my chest, and shouted, ‘I’m going to shoot you—you
are a shirker.’ He followed up this remark by a few
more specimens of invective, thrust his hand into my pocket
and grabbed the key, saying, ‘I am the only person who gives
orders here.’ This occurred in the presence of numerous
Germans and Ukrainians.”</p>
</div>
<p class="pindent">The chief of the main department, Dr. Moisich, relates the
same story in a report to the Commissioner General of Zhitomir,
dated 4 December 1943. All these documents are being presented in
their original form to the Tribunal.</p>
<p class="pindent">I shall now, Your Honors, proceed to read excerpts from the
official reports and communiques of the Extraordinary State Commission
of the Soviet Union for the investigation and establishment
of crimes committed by the German intruders and their accomplices.
In order to save time, I ask the Tribunal to permit me to read
<span id="Page_35" title="35"></span>
only a few excerpts from these documents, and to give you the
contents of the rest in my own words.</p>
<p class="pindent">The report of the Extraordinary State Commission on the
looting and crimes perpetrated by the Hitlerites in the city and
district of Rovno has already been submitted to the Tribunal as
Document Number USSR-45. The corresponding section of this
report reads as follows:</p>
<div class="blockquote">
<p class="calibre3">“During their stay in Rovno and the district, Hitlerite officers
and soldiers unrestrainedly plundered the peaceful Soviet
citizens and thoroughly looted the property of cultural and
educational institutions.”</p>
</div>
<p class="pindent">I shall not quote all the data mentioned in this report of the
Extraordinary State Commission. The report made by the Extraordinary
State Commission on the atrocities committed by the
Hitlerites in Kiev, and submitted to the Tribunal as Document
Number USSR-9, emphasizes the fact that the Hitlerites plundered
the peaceful population of Kiev. I quote a brief extract, “The
German occupation forces in the city of Kiev looted factory equipment
and carried it off to Germany.”</p>
<p class="pindent">Following the directives of the criminal German Government
and the Supreme Command of the German Armed Forces, the
satellite states also joined in plundering and other crimes. Romanian
troops who temporarily occupied Odessa along with German Armed
Forces plundered this flourishing city in accordance with instructions
from their German masters. The report of the Extraordinary
State Commission concerning the crimes committed by German and
Romanian invaders in Odessa reads in part as follows:</p>
<div class="blockquote">
<p class="calibre3">“. . . The Romanians damaged Odessa considerably from the
economic and industrial point of view during the occupation.</p>
<p class="calibre3">“German-Romanian aggressors have confiscated and removed
to Romania 1,042,013 centners of grain, 45,227 horses, 87,646
head of cattle, 31,821 pigs, <span class="it1">et cetera</span>, belonging to co-operative
farms and co-operative farmers.”</p>
</div>
<p class="pindent">The report of the Extraordinary State Commission on the
damages inflicted by the German fascist invaders on industry, urban
economy, and cultural and educational institutions in the Stalino
region, already presented to the Tribunal as Document Number
USSR-2, also gives a good deal of data on the looting and removal to
Germany of the factory equipment of this important industrial
region.</p>
<p class="pindent">I have quoted only a few of the reports compiled by the Extraordinary
State Commission on certain districts of the Ukraine. This
flourishing Soviet republic was subjected to unrestrained looting
by the Hitlerites. The Hitlerite conspirators considered the Ukraine
<span id="Page_36" title="36"></span>
a tidbit and plundered her with exceptional voracity. I should like
to read several documents in proof of the above.</p>
<p class="pindent">Rosenberg’s letter to Reichsleiter Bormann dated 17 October
1944. This document which has already been submitted on 17 December
by the United States Prosecution under Exhibit Number
USA-338 (Document Number 327-PS) states that the Central Trading
Company for the East for marketing of agricultural produce sent
the following goods to Germany in the period between 1943 and
31 March 1944 only:</p>
<div class="blockquote">
<p class="calibre3">“Cereals, 9,200,000 tons; meat and meat products, 622,000 tons;
oil seed, 950,000 tons; butter, 208,000 tons; sugar, 400,000 tons;
fodder, 2,500,000 tons; potatoes, 3,200,000 tons, and so forth.”</p>
</div>
<p class="pindent">The Defendant Rosenberg reported his “agricultural achievements”
to Hitler’s closest assistant in these terms.</p>
<p class="pindent">It should be noted that during the first year of the war the
voracity shown by the Hitlerites in plundering the Ukraine was so
great, that it awakened certain misgivings even in themselves.</p>
<p class="pindent">I shall read an excerpt from a letter addressed by the Inspector
of Armaments in the Ukraine to the Infantry General Thomas, Chief
of the Economic Armament Office of the OKW. The letter is dated
2 December 1941. This document was submitted to the Tribunal by
the United States Prosecution on 14 December as Document Number
3257-PS. I read a short excerpt:</p>
<div class="blockquote">
<p class="calibre3">“The export of agricultural surpluses from the Ukraine for
the purpose of feeding the Reich is only possible if the internal
trade in the Ukraine is reduced to a minimum. This can be
attained by the following measures:</p>
<p class="calibre3">“1. Elimination of unwanted consumers (Jews; the populations
of the large Ukrainian towns, which, like Kiev, receive no
food allocation whatsoever).</p>
<p class="calibre3">“2. Reduction as far as possible of food rations allocated to
the Ukrainians in other towns.</p>
<p class="calibre3">“3. Reduction of food consumption by the peasant population.”</p>
</div>
<p class="pindent">Having outlined this program, the author explains further:</p>
<div class="blockquote">
<p class="calibre3">“If the Ukrainian is to be made to work, we must look after
his physical existence, not for sentimental motives, but for
purely business reasons.”</p>
</div>
<p class="pindent">I omit the next paragraphs of this quotation.</p>
<p class="pindent">However, the Reich Commissioner for the Ukraine, Koch, went
steadily on with his policy of ruthlessly plundering the Ukraine.
In due course I shall submit to you numerous further documents,
also in the original, in confirmation of the above. Koch’s policy met
with the approbation of the Hitlerite Government.
<span id="Page_37" title="37"></span></p>
<p class="pindent">It is worthy of note that at the beginning of the war the plundering
of the occupied territories of the U.S.S.R. was organized in
accordance with the directives contained in the Green File, already
mentioned. I submit to the Tribunal, as Exhibit Number USSR-13
(Document Number USSR-13), a letter by Göring dated 6 September
1941 on the subject of inspection for the seizure and utilization of
raw materials, in which, among other things, the following passage
occurs—the Tribunal will find this excerpt on Page 131 of the document
book:</p>
<div class="blockquote">
<p class="calibre3">“The war emergency demands that the supplies of raw
materials found in the recently captured eastern territories
be put at the disposal of the German war economy as quickly
as possible. The Directives for the Economic Management of
the Occupied Eastern Territories (Green File) are to be taken
as authoritative.”</p>
</div>
<p class="pindent">I omit the last part of the quotation.</p>
<p class="pindent">Later however, when the Germans set up their so-called civil
administration and organized a number of special economic bodies
in various occupied territories including the Ukraine, in particular,
disputes arose among the numerous German military and civil
bodies and organizations, all of whom were engaged in plundering
the occupied territories. Rosenberg, as Reich Minister for the Eastern
Occupied Territories, began to insist that all military and economic
organizations in the Ukraine were to be liquidated and their functions
transferred to German civil administrations.</p>
<p class="pindent">I submit to the Tribunal a draft report for State Secretary
Körner on this subject, dated 3 December 1943, as Exhibit Number
USSR-180 (Document Number USSR-180). I read from it:</p>
<div class="blockquote">
<p class="calibre3">“Subject, 1. Economic administration in the Occupied Eastern
Territories; 2. General economic staff for the occupied territories.</p>
<p class="calibre3">“In a letter to the Reich Marshal, dated 20 November 1943,
copies of which were sent to the Chief of Staff of the OKW,
and the Leader of the Party Chancellery, Minister Rosenberg
made the following demands:</p>
<p class="calibre3">“1. For the Ukraine,</p>
<p class="calibre3">“a. Military economic establishment still in existence to be
dissolved.</p>
<p class="calibre3">“b. The office of Chief of the Army Group Economic Departments
to be abolished and the military functions of the latter
to be taken over again by the Chief Quartermaster.</p>
<p class="calibre3">“c. In case of the retention of the office of the Chief of the
Army Group Economic Departments the practice of the same
specialists working both in the Reich Commissariat and under
<span id="Page_38" title="38"></span>
the Chief of the Army Group Economic Departments to be
discontinued.”</p>
</div>
<p class="pindent">I omit the rest. In the same draft are detailed objections made
by General Stapf and submitted by him to Keitel. He criticizes
Rosenberg’s suggestion and advises the retention of the Economic
Staff East.</p>
<p class="pindent">And now, with the permission of the Tribunal, I present as
Exhibit Number USSR-174 (Document Number USSR-174), another
original document which is a covering letter from the Permanent
Deputy of the Reich Minister for the Occupied Eastern Territories
to State Secretary Körner on the same subject.</p>
<p class="pindent">Written suggestions by Rosenberg were appended to this letter
in which Rosenberg insists that the entire economic activities be
placed under the control of his ministry once more. As this is a
rather long document and I am presenting it in the original, I ask
your permission not to read it since it is mainly concerned with
Rosenberg’s proposal, which I have already described to the Tribunal.
For the information of the interpreters—I omit two pages
of my presentation and pass to Page 62.</p>
<p class="pindent">Evidently Rosenberg did not receive the answer he wanted, so
on 24 January 1944 he again wrote to Göring on the same subject.
I submit this letter as Exhibit Number USSR-179 (Document Number
USSR-179). In this letter Rosenberg suggests—I shall read into the
record a short quotation, which the Tribunal will find on Page 151
of the document book:</p>
<div class="blockquote">
<p class="calibre3">“. . . in the interest of smooth working and economy of staff,
I would request that the Economic Staff East and its subordinate
agencies be abolished and that the economic administration
in the Occupied Eastern Territories and even in
those districts where fighting is still going on, be transferred
to my sphere of authority.”</p>
</div>
<p class="pindent">Göring replied to this in a letter dated 14 February, which I offer
in evidence as part of the same Exhibit Number USSR-179. I quote:</p>
<div class="blockquote">
<p class="calibre3">“Dear Party Member Rosenberg:</p>
<p class="calibre3">“I received your letter of 24 January 1944 regarding economic
administration in the Occupied Eastern Territories. Since the
Reich Commissariat Ukraine is now almost entirely army
administrative territory”—this is a reference to the Red
Army offensive—“I consider it advisable to postpone our
conference on the future organization of the economic administration
until the military situation is completely clarified.”</p>
</div>
<p class="pindent">Thus, Your Honors, Rosenberg’s claims met with resistance on
the part of other German authorities who stubbornly refused to
give up such a choice “economic activity.”
<span id="Page_39" title="39"></span></p>
<p class="pindent">Rosenberg in his turn refused to yield and continued to press
his demands. I now offer in evidence the following document,
Exhibit Number USSR-173 (Document Number USSR-173)—this is
a letter from Rosenberg to Göring dated 6 March 1944. In this
letter, Rosenberg refers to his experience in Bielorussia and again
urges his proposals. It is a long document and I shall not read it,
as it is presented to the Tribunal <span class="it1">in toto</span>. But Göring still had his
doubts and decided against Rosenberg.</p>
<p class="pindent">On 6 April 1944, a month after the above-mentioned letter was
sent off, Rosenberg again wrote to Göring. This document I submit
to the Tribunal as Exhibit Number USSR-176 (Document Number
USSR-176). May I omit reading it into the record, since in substance
it is like the last; and the arguments advanced in it are not
such as to interest us greatly now. I omit Page 65 and pass on to
Page 66.</p>
<p class="pindent">Thus, Your Honors, even when the Red Army was delivering its
last crippling blows against the German fascist hordes, the Hitlerite
brigands went on quarreling about the spoils. I think there is no
need to prove that while this haggling continued, the occupied
territories were looted in feverish haste by the German authorities,
both military and civil.</p>
<p class="pindent">Now, Your Honors, I shall read some brief excerpts from the
report made by the Extraordinary State Commission of the Soviet
Union on the crimes committed by the Hitlerite invaders in the
Lithuanian, Latvian, and Estonian Soviet Socialist Republics, which
were also mercilessly plundered by the German fascist aggressors.</p>
<p class="pindent">All these reports have been already presented to the Tribunal
by the Soviet Prosecution. The report of the Extraordinary State
Commission on the crimes of the Hitlerites in the Lithuanian Soviet
Socialist Republic contains the following statement:</p>
<div class="blockquote">
<p class="calibre3">“As the result of the way in which the Hitlerite invaders
managed affairs, even according to incomplete data, the
number of livestock and poultry in all the 14 districts of the
Lithuanian S.S.R. decreases in comparison with the year
1940-41 by 136,140 horses, 565,995 cattle, 463,340 pigs. . . .”</p>
</div>
<p class="pindent">I shall now quote excerpts from the report of the Extraordinary
State Commission on the crimes committed by the German invaders
in the Latvian Soviet Socialist Republic. For the information of
the interpreters—this quotation is on Page 68, second paragraph:</p>
<div class="blockquote">
<p class="calibre3">“The Germans plundered the depots of tractors and agricultural
machinery throughout Latvia; and according to figures
which are far from complete, they sent to Germany 700 tractors,
180 motor vehicles, 4,057 ploughs, 2,815 cultivators, 3,532
harrows.”</p>
</div>
<p class="pindent"><span id="Page_40" title="40"></span></p>
<p class="pindent">Second quotation:</p>
<div class="blockquote">
<p class="calibre3">“In consequence of the despoliation of Latvian rural economy
by the German invaders, the livestock in Latvia was decreased
by 127,300 horses, 443,700 head of cattle, 318,200 pigs, and
593,800 sheep.”</p>
</div>
<p class="pindent">Further, I shall read a short excerpt from the report of the
Extraordinary State Commission on the Estonian S.S.R.: I quote:</p>
<div class="blockquote">
<p class="calibre3">“The German invaders plundered the rural population of
Estonia without restraint. This plunder took the form of
forcing the peasants to hand over various kinds of farm
produce.</p>
<p class="calibre3">“The quantities of farm produce to be delivered as ordered
by the Germans were very high.”</p>
</div>
<p class="pindent">I omit part of the quotation and I read the second paragraph
on the next page:</p>
<div class="blockquote">
<p class="calibre3">“The Germans confiscated and drove to Germany 107,000
horses, 31,000 cows, 214,000 pigs, 790,000 head of poultry.
They plundered about 50,000 beehives.”</p>
</div>
<p class="pindent">I omit one more paragraph and I read the last quotation from
this report:</p>
<div class="blockquote">
<p class="calibre3">“The Hitlerites took away 1,000 threshing machines, 600
threshing machine motors, 700 motors for driving belts, 350
tractors, and 24,781 other agricultural machines which were
the personal property of individual peasants.”</p>
</div>
<p class="pindent">Your Honors, a similar policy of plundering private, public, and
national property was also carried out by the German fascist
invaders in the occupied territories of Bielorussia, Moldavia, the
Karelo-Finnish S.S.R. and the Russian Soviet Federated Socialist
Republic.</p>
<p class="pindent">Various military units and organizations in different districts of
the U.S.S.R. employed the same methods of plunder at all stages
of the war in accordance with the same criminal plan and in pursuit
of the same criminal aims. This plan was worked out, these aims
were determined, these crimes were organized by the major war
criminals who are now in the dock.</p>
<p class="pindent">The U.S.S.R. Prosecution has at its disposal tens of thousands of
documents on this subject. The presentation of all these numerous
documents to the Tribunal would require such a long time that it
would only complicate the Trial. For this reason, with the Tribunal’s
permission, I shall not quote any further documents or
reports of the Extraordinary State Commission on separate regions
and republics, but I shall read into the record the statistical report
of the Extraordinary State Commission relative to the material
damage done by the German fascists to state enterprises and
<span id="Page_41" title="41"></span>
establishments, collective farms, public organizations, and individual
citizens of the U.S.S.R.</p>
<p class="pindent">This document is being presented to the Tribunal as Exhibit
Number USSR-35 (Document Number USSR-35). I shall read into
the record only those extracts from the report which have a direct
bearing on the subject of my presentation. They are stated as
follows—Page 71 of the statement:</p>
<div class="blockquote">
<p class="calibre3">“The German fascist aggressors destroyed and pillaged 98,000
collective farms, 1,876 State farms, and 2,890 machine and
tractor stations. Seven million horses, 17 million head of
cattle, 20 million pigs, 27 million sheep and goats, and
110 million poultry were slaughtered or shipped to Germany.”</p>
</div>
<p class="pindent">The Extraordinary State Commission calculates the damage done
to the national economy of the Soviet Union and to individual
villagers and townspeople at 679,000 millions of rubles reckoned at
the official prices current in 1941 as follows:</p>
<div class="blockquote">
<p class="calibre3">“1. State concerns and institutions, 287,000 million rubles;
2. collective farms, 181,000 million rubles; 3. villagers and
townspeople, 192,000 million rubles; 4. co-operatives, trade
unions, and other public organizations, 19,000 million rubles.”</p>
</div>
<p class="pindent">I omit the following sections of this report, which describe how
this damage is divided among separate Soviet Republics, and I pass
on to the fourth paragraph, which describes the destruction of collective
farms, State farms, and machine tractor stations. In order
to save time, I shall confine myself to a few separate excerpts:</p>
<div class="blockquote">
<p class="calibre3">“While burning the villages and hamlets, the German fascists
plundered completely the inhabitants of these villages. Those of
the peasants who offered resistance were brutally murdered.”</p>
</div>
<p class="pindent">Further, some concrete data are given on the plundering in the
Kamenetz-Podolsk and the Kursk region, the collective farm “For
Peace and Work” in the region of Krasnodar, the collective farms
“For the Times” in the Stalino region, as well as collective farms
in Mogilev and Zhitomir districts and others. The German fascist
invaders inflicted great damage on the State farms of the U.S.S.R.
They shipped out of collective farms all stocks of agricultural products
and destroyed farm and other buildings belonging to the
state farms.</p>
<p class="pindent">Another excerpt:</p>
<div class="blockquote">
<p class="calibre3">“Horse Farm Number 62 in the Poltava district lost its stock
of Russo-American trotting brood mares through the German
occupation. Up to the war, this stud farm had 670 brood
mares. The Germans acted in the same way in regard to
other breeding farms.”</p>
</div>
<p class="pindent"><span id="Page_42" title="42"></span></p>
<p class="pindent">I omit the remaining excerpt of this section; and I pass on to
Paragraph 6, which deals with the mass looting of Soviet citizens’
property by the Germans:</p>
<div class="blockquote">
<p class="calibre3">“In all the republics, districts, and territories of the Soviet
Union which were occupied, the fascist German invaders
looted the property of the rural and urban population,
stealing valuables, property, clothing, and household articles,
and imposing fines, taxes, and contributions on the peaceful
population.”</p>
</div>
<p class="pindent">The same section contains a whole series of concrete facts of
the plunder of Soviet citizens in Smolensk, Orel and Leningrad
Provinces; the Dniepropetrovsk and Sumsky Provinces, <span class="it1">et cetera</span>.
With the Tribunal’s permission, I omit two pages of my presentation,
and I read the following paragraph at the bottom of Page 76:</p>
<div class="blockquote">
<p class="calibre3">“The plundering of the Soviet population was being carried
out by the German aggressors throughout the whole of the
occupied Soviet territory.</p>
<p class="calibre3">“The Extraordinary State Commission has undertaken the
task of estimating the damage done to the Soviet citizens
by the occupation authorities and has established that the
German fascist invaders burned down and destroyed approximately
four million dwelling houses which were the personal
property of collective farmers, workers, and employees;
confiscated 1½ million horses, 9 million head of cattle,
12 million pigs, 13 million sheep and goats; and took away
an enormous quantity of household goods and chattel of all
kinds.”</p>
</div>
<p class="pindent">The above documents and reports of the Extraordinary State
Commission depict the crimes committed by the Hitlerites in the
occupied territories of the U.S.S.R. These crimes had been organized
by the defendants.</p>
<p class="pindent">The fact that Göring, in his capacity as Reich Marshal and
Plenipotentiary for the Four Year Plan of the Hitlerite Government,
was directly in charge of all the operations of the German
military and civil authorities for the preparation and execution of
despoliation of the occupied territories, is clearly shown by the
documents which I have already presented. Nevertheless, I beg the
indulgence of the Tribunal to read the final document on this matter,
that is, the decree issued by Hitler on 29 June 1941.</p>
<p class="pindent">A copy of this decree was kindly put at our disposal by the
American Prosecution, and it has not yet been presented. I, therefore,
present it to the Tribunal as Exhibit Number USSR-287 (Document
Number USSR-287). This decree reads as follows:</p>
<div class="blockquote">
<p class="calibre3">“1. Reich Marshal Hermann Göring, as Plenipotentiary for
the Four Year Plan, will employ, within the scope of the
<span id="Page_43" title="43"></span>
power allotted to him for the purpose, all means necessary
for exploiting to the fullest extent supplies and economic
resources discovered in the newly occupied eastern territories
and for developing all their economic possibilities for
the benefit of the German war economy.</p>
<p class="calibre3">“2. For this purpose he is also authorized to give direct orders
to military authorities in the newly occupied eastern territories.</p>
<p class="calibre3">“3. This decree will become effective as from today. It must
first be made public by special order.”</p>
</div>
<p class="pindent">However, Your Honors, the granting of extraordinary powers
to Göring does not, in any way, mean that the other defendants
took only a passive interest in organizing the looting of the
occupied territories. All of them, jointly and separately, worked
feverishly in this direction. Frank robbed the Poles; Rosenberg
managed affairs in the Ukraine and in the other occupied territories
of the U.S.S.R.; Sauckel and Seyss-Inquart were busy here
and there; Speer and Funk made schemes for and carried out
predatory measures within the scope of the Ministry of Economics
and the Ministry for Armament and War Production, while Keitel
acted in the field of the Armed Forces.</p>
<p class="pindent">In this connection I should like to submit to the Tribunal two
more documents relating to Keitel’s economic activities. These
documents, Your Honors, are presented to the Tribunal as Exhibit
Number USSR-175 (Document Number USSR-175). On 29 August
1942 Keitel, in his capacity of Chief of the Supreme Command
of the Armed Forces, issued the following order under “Number
002865/42-g.Kdos. regarding securing of supplies for the Armed
Forces.” I shall read only two short excerpts from this order. Your
Honors will find them on Page 181 of the document book. I read:</p>
<div class="blockquote">
<p class="calibre3">“The food situation of the German people is such that it is
necessary for the Armed Forces to contribute as far as
possible towards alleviating it. All the necessary means of
doing so exist in the combat zones and in the occupied
territories both in the East and in the West.</p>
<p class="calibre3">“It is essential, above all, that much greater quantities of
supplies and forage . . . should be secured in the occupied
territories of the East than has been the case up to now.”</p>
</div>
<p class="pindent">The second excerpt:</p>
<div class="blockquote">
<p class="calibre3">“All establishments should consider it their pride as well
as their duty to attain this goal at all costs so that in this
field, too, they may play a decisive part in achieving victory.”</p>
</div>
<p class="pindent">In a memorandum by section chiefs Klare and Dr. Bergmann,
dated, “19 November 1942, most secret, subject: Procurement of
<span id="Page_44" title="44"></span>
Supplies for the Armed Forces”—I submit this memorandum in
the original to the Tribunal under the same number, Document
Number USSR-175—we find the following estimate of the results
achieved by the above-mentioned order from Keitel. I now read
into the record only the first paragraph of this memorandum.</p>
<div class="blockquote">
<p class="calibre3">“By order of the Führer, the Chief of the OKW has decreed
in the attached order of 29 August 1942 that the Armed
Forces must, as far as possible, contribute towards the task
of ensuring food supplies for the German people and that
they must themselves make every effort, not only to obtain
sufficient food supplies locally to cover the needs of the
armies, but also to ensure that the quantities required by
the Reich are secured in addition.</p>
<p class="calibre3">“As the result of this order co-operation between the Army
and the economic authorities has fortunately grown closer.”</p>
</div>
<p class="pindent">Now with Your Honor’s permission, I shall read into the record
one more document, namely, a telegram sent by Keitel on 8 September
1944. This document was kindly put at our disposal by
the American Prosecution and registered as Document Number
743-PS. It was not presented to the Tribunal before; I therefore
submit it now as Exhibit Number USSR-286, and I quote:</p>
<div class="blockquote">
<p class="calibre3">“1. To General Staff of the Army: Attention General Quartermaster,
Office of Chief of Staff, (Anna).</p>
<p class="calibre3">“2. To General Staff of the Army: Attention General Quartermaster,
Army Administration Office, (Anna-Bu).</p>
<p class="calibre3">“3. To Commanding General, Army Group North.</p>
<p class="calibre3">“4. To Commanding General, Army Group Center.</p>
<p class="calibre3">“5. To Economic Staff East.</p>
<p class="calibre3">“6. To Military District H.Q.I.”</p>
</div>
<p class="pindent">I read this text as follows:</p>
<div class="blockquote">
<p class="calibre3">“1. The Führer has entrusted Gauleiter Koch with the utilization
of local resources in the parts of Reichskommissariat
Ostland occupied by troops of Army Group Center. Furthermore,
the Führer has ordered that all German and local
administrative authorities be subordinated to Gauleiter Koch.
In securing economic resources, Gauleiter Koch is to maintain
contact with competent Supreme Reich agencies.</p>
<p class="calibre3">“2. All authorities of the Armed Forces will give Gauleiter
Koch every assistance in their power in executing this order.”</p>
</div>
<p class="pindent">Thus, Your Honors, even at the end of 1944, when under the
blows of the Red Army and its allies Hitlerite Germany was
precipitated towards its final defeat and only a few months before
its final military and political collapse, Hitler, Keitel, Koch, and
<span id="Page_45" title="45"></span>
many others were still stretching out their already stiffening fingers
to grab the property and wealth of others.</p>
<p class="pindent">This is the evidence I have to show regarding the looting and
marauding perpetrated by the Hitlerite hordes in the occupied
territories of the Soviet Union. But they plundered not only the
living, they also plundered the dead. My colleague, Colonel
Smirnov, has already presented comprehensive evidence on this
question. I do not wish to quote it again, but I refer to it only
to show how closely interlocked and all-embracing was the circle
of their crimes. As Rauschning testifies in his book, which has
already been presented by the Soviet Prosecution to the Tribunal,
Hitler once said:</p>
<div class="blockquote">
<p class="calibre3">“I need people with strong fists whose principles will not
prevent them from taking human life if necessary; and if on
occasion they swipe a watch or a jewel, I don’t care a tinker’s
damn.”</p>
</div>
<p class="pindent">And Hitler actually found these men in the persons of the
defendants and their numerous accomplices.</p>
<p class="pindent">As the documents which I have just presented show, the
Defendant Göring, on account of his position in Hitler’s Government
as Reich Marshal and Plenipotentiary for the Four Year
Plan and as head of the whole criminal system for the plundering
of the occupied territories, was guilty of these crimes.</p>
<p class="pindent">For this reason the stenographic record of a secret conference
of German administrative leaders (Reich Commissioners) for the
occupied countries, which took place on 6 August 1942, is of
particular interest. Göring presided over the meeting. This
document, like many other original documents which I had the
honor of presenting today to the Tribunal, was found by Soviet
military authorities in September 1945 in one of the municipal
buildings of the town of Jena, in Thuringia.</p>
<p class="pindent">This extraordinary document contains a long speech by Göring
and the replies of the Hitlerite rulers of the occupied countries.
And, Your Honors, many of the people who are sitting in the
dock now took part in this conference. The contents of this document
are such that any comment on my part is unnecessary.
Therefore, if it pleases the Tribunal, I shall proceed to read from
this document.</p>
<div class="blockquote">
<p class="calibre3">“Stenographic notes; Thursday, 6 August 1942, 4 p. m., in
the Hermann Göring Hall in the Air Ministry.</p>
<p class="calibre3">“Reich Marshal Göring: ‘The Gauleiter stated their views here
yesterday. Although they may have differed in tone and
manner, it was evident that they all feel that the German
people have too little to eat. Gentlemen, the Führer has
<span id="Page_46" title="46"></span>
given me general powers exceeding any hitherto granted
within the Four Year Plan.</p>
<p class="calibre3">“ ‘At this moment Germany commands the richest granaries
that ever existed in the European area, stretching from the
Atlantic to the Volga and the Caucasus, lands more highly
developed and fruitful than ever before, even if a few of
them cannot be described as granaries. I need only remind
you of the fabulous fertility of the Netherlands, the unique
paradise that is France. Belgium too is extraordinarily fruitful
and so is the province of Posen. Then, above all, the
Government General has to a great extent the rye and wheat
granary of Europe, and along with it the amazingly fertile
districts of Lemberg (Lvov) and Galicia, where the harvest
is exceptionally good. Then there comes Russia, the black
earth of the Ukraine on both shores of the Dnieper, the
Don region, with its remarkably fertile districts which have
scarcely been destroyed. Our troops have now occupied, or
are in process of occupying, the excessively fertile districts
between the Don and the Caucasus.’ ”</p>
</div>
<p class="pindent">Göring then goes on to say:</p>
<div class="blockquote">
<p class="calibre3">“ ‘God knows, you are not sent out there to work for the
welfare of the people in your charge but to squeeze the
utmost out of them, so that the German people may live.
That is what I expect of your exertions. This everlasting
concern about foreign peoples must cease now, once and for all.</p>
<p class="calibre3">“ ‘I have here before me reports on what you expect to be
able to deliver. It is nothing at all when I consider your
territories. It makes no difference to me if you say that your
people are starving.</p>
<p class="calibre3">“ ‘One thing I shall certainly do. I will make you deliver
the quantities asked of you; and if you cannot do so, I will
set forces to work that will force you to do so whether
you want to or not.</p>
<p class="calibre3">“ ‘The wealth of Holland lies close to the Ruhr. It could
send a much greater quantity of vegetables into this stricken
area now than it has done so far. What do I care what
the Dutchmen think of it.</p>
<p class="calibre3">“ ‘The only people in whom I am interested in the occupied
territories are those who work to provide armaments and
food supplies. They must receive just enough to enable them
to continue working. It is all one to me whether Dutchmen
are Germanic or not. They are only all the greater blockheads
if they are; and more important persons than they have
shown in the past how Germanic numskulls sometimes have
<span id="Page_47" title="47"></span>
to be treated. Even if you receive abuses from every quarter,
you will have acted rightly, for it is the Reich alone that
counts.’ ”</p>
</div>
<p class="pindent">And now I come to the next excerpt:</p>
<div class="blockquote">
<p class="calibre3">“ ‘I am still discussing the western territories. Belgium
has taken care of herself extraordinarily well. That was
very sensible of Belgium. But there, too, gentlemen, rage
incarnate could seize me. If every plot of ground in Belgium
is planted with vegetables, then they must surely have had
vegetable seed. When Germany wanted to start a big
campaign last year for utilizing uncultivated land, we did
not have nearly as much seed as we needed. Neither Holland
nor Belgium nor France have delivered it, although I myself
was able to count 170 sacks of vegetable seed on a single
street in Paris. It is all very well for the French to plant
vegetables for themselves. They are accustomed to doing
this. But, gentlemen, these people are all our enemies and
you will not win over any of them by humane measures. The
people are polite to us now because they have to be polite.
But let the English once force their way in and then you will
see the real face of the Frenchman. The same Frenchman
who dines with you and in turn invites you to dine with him
will at once make it plain to you that the Frenchman is a
German-hater. That is the situation, and we do not want
to see it any other way than it is.</p>
<p class="calibre3">“ ‘It is a matter of indifference to me how many courses are
served every day at the table of the Belgian king. The
king is a prisoner of war; and if he is not treated as such, I
will see to it that he is taken to some other place where this
can be made clear to him. I am really fed up with the
business.</p>
<p class="calibre3">“ ‘I have forgotten one country because nothing is to be had
there except fish; that is Norway.</p>
<p class="calibre3">“ ‘With regard to France, I say that it is still not cultivated
to the greatest possible extent. France can be cultivated in
a very different way if the peasants there are forced to work
in a different manner. Secondly, inside France itself the
population is gorging itself to a scandalous degree. . . .</p>
<p class="calibre3">“ ‘Besides, Heaven help a German car parked outside a
French tavern in Paris! it is reported. But a whole row of
French gasoline-driven vehicles parked there doesn’t bother
anyone.</p>
<p class="calibre3">“ ‘I would say nothing at all, on the contrary, I would not
think much of you if we didn’t have a marvelous restaurant
in Paris where we could get the best food obtainable. But
<span id="Page_48" title="48"></span>
I do not want the French to be able to saunter into it. Maxim
must have the best food for us.’ ”</p>
</div>
<p class="pindent">Mr. President, I see one of the German Defense Counsel
wishes to take the floor. I shall, therefore, give him an
opportunity to do so.</p>
<p class="pindent">DR. ALFRED THOMA (Counsel for Defendant Rosenberg): Mr.
President, I have only a short question.</p>
<p class="pindent">The prosecutor has not told us where this document can be
found, in which document book and what number it has. He
mentioned only the page on which the Court can find that
document.</p>
<p class="pindent">MR. COUNSELLOR SHENIN: This document was presented to
the Tribunal as Document Number USSR-170. The photostatic
copy was turned over to Defense Counsel.</p>
<p class="pindent">May I continue, Mr. President?</p>
<p class="pindent">THE PRESIDENT: It comes from the archives of the Defendant
Göring, does it not? You have so stated.</p>
<p class="pindent">MR. COUNSELLOR SHENIN: Yes.</p>
<div class="blockquote">
<p class="calibre3">“ ‘For German officers and men three or four first-class
restaurants—excellent, but not for the French.’ ”</p>
</div>
<p class="pindent">I quote the next excerpt:</p>
<div class="blockquote">
<p class="calibre3">“ ‘Furthermore, you should be like bloodhounds on the track
of anything the German people can use; that stuff should be
brought here out of the warehouses like lightning. Whenever
I issued a decree, I stated repeatedly that soldiers are entitled
to buy as much as they want and whatever they want, as
much as they can carry. . . .</p>
<p class="calibre3">“ ‘Now you will say—Laval’s foreign policy. Herr Laval
calms down Herr Abetz and as far as I am concerned, may
go to Maxim’s, although it is out of bounds. But the French
will soon have to learn. You have no idea of the impudence
they have. When our friends hear that a German is interested
they charge fantastic prices. They charge three times the
normal price and if they hear that the Reich Marshal is in
the market, they charge five times the normal price. I
wanted to buy a tapestry. Two million francs was asked.
The woman was told that the buyer wanted to see the
tapestry. She said she did not wish to let it out of her
sight. Well, then she would have to go with it. She was
told that she was going to see the Reich Marshal. When she
arrived the tapestry was priced at 3 million francs. I reported
it. Do you think anything was done? I submitted the case
to the French court and they taught milady that it is
inadvisable to profiteer when dealing with me.
<span id="Page_49" title="49"></span></p>
<p class="calibre3">“ ‘All that interests me is what we can squeeze out of the
territory now under our control with the utmost application
and by straining every nerve; and how much of that can
be diverted to Germany. I don’t give a damn about import
and export statistics of former years.</p>
<p class="calibre3">“ ‘Now, regarding shipments to the Reich. Last year France
shipped 550,000 tons of grain, and now I demand 1.2 million
tons. Two weeks from now a plan will be submitted for
handling it. There will be no more discussion about it.
What happens to the Frenchmen is of no importance. One
million two hundred thousand tons will be delivered. Fodder—last
year 550,000 tons, now 1 million; meat—last year 135,000
tons, now 350,000; fats—last year 23,000, this year 60,000.’ ”</p>
</div>
<p class="line12">And so on.</p>
<p class="pindent">The next excerpt from this address concerns the quotas to be
fixed for deliveries from countries such as the Netherlands, Belgium,
Norway, and the Government General. In reply to Göring’s
questions and instructions definite figures were quoted by those
attending the meeting. I omit one page and continue:</p>
<div class="blockquote">
<p class="calibre3">“Reich Marshal Göring: ‘So much for the West. A special
order will be issued concerning purchasers who buy up all
the clothes, shoes, <span class="it1">et cetera</span>, that are to be had.</p>
<p class="calibre3">“ ‘Now comes the East. I have settled this point with the
Wehrmacht. The Wehrmacht waives the demands it made
on the home country. How much hay was required?’</p>
<p class="calibre3">“Backe: ‘1.5 million tons. Over 1 million tons straw and
1½ million tons oats. We can’t manage that.(?)’</p>
<p class="calibre3">“Reich Marshal Göring: ‘Now, gentlemen, there is only one
thing more regarding Wehrmacht supplies. I want to hear
nothing more about you until further notice. No more
requests. The country—with its sour cream, apples, and
white bread—will feed us abundantly. The Don valley will
take care of the rest.’ ”</p>
</div>
<p class="pindent">Passing to the next quotation—Göring is speaking:</p>
<div class="blockquote">
<p class="calibre3">“ ‘The Wehrmacht in France will, of course, be supplied
with food by France. That is a matter of course, and I did
not even mention it before.</p>
<p class="calibre3">“ ‘Now about Russia: There is no doubt of her fertility. The
position there is almost incredibly good. . . .’ ”</p>
</div>
<p class="pindent">The next quotation—Göring is still speaking:</p>
<div class="blockquote">
<p class="calibre3">“ ‘I was glad to hear that the Reich Commissioner in Ostland
is doing just as well, and the people are just as fat and
chubby and puff a little when they work. Nevertheless, I
shall see to it, no matter how carefully certain groups are
<span id="Page_50" title="50"></span>
treated, that some contribution is made from the inexhaustible
fertility of this area.’ ”</p>
</div>
<p class="pindent">After this Lohse, Reich Commissioner for Bielorussia, addressed
the meeting:</p>
<div class="blockquote">
<p class="calibre3">“ ‘May I state my opinion in a few words? I should like
to give you more but certain conditions have to be observed.
The harvest is certainly excellent but in more than half of
the area of Bielorussia which is well cultivated, it is scarcely
possible to get in the crops, unless we can put a stop to the
disturbances caused by guerrillas and partisans. I have already
been crying out for help for 4 months.’ ”</p>
</div>
<p class="pindent">Lohse goes on to describe the activities of the partisans in
Bielorussia. In this connection Göring interrupts him and says:</p>
<div class="blockquote">
<p class="calibre3">“ ‘My dear Lohse, we have known each other for a long
time. I know well enough that you are a great poet.’ ”</p>
</div>
<p class="pindent">And Lohse answered:</p>
<div class="blockquote">
<p class="calibre3">“ ‘I won’t stand for that; I have never written poetry.’ ”</p>
</div>
<p class="pindent">In conclusion I quote the last three quotations from Göring’s
speech. He said:</p>
<div class="blockquote">
<p class="calibre3">“ ‘We must have buyers from the Ministry of Economics,
Funk, in the Ukraine and elsewhere. We must send them to
Venice to buy odds and ends, those frightful alabaster things
and cheap jewelry, <span class="it1">et cetera</span>. I don’t think there is any
other place except Italy where one gets quite such junk.</p>
<p class="calibre3">“ ‘Now let us see what Russia can deliver. I think, Riecke,
we should be able to get 2 million tons of cereals and fodder
out of the whole of Russia.’</p>
<p class="calibre3">“Riecke: ‘That can be done.’</p>
<p class="calibre3">“Reich Marshal Göring: ‘That means that we must get 3 million,
apart from Wehrmacht supplies.’</p>
<p class="calibre3">“Riecke: ‘No, all that is in the front areas goes for the Wehrmacht
only.’</p>
<p class="calibre3">“Reich Marshal Göring: ‘Then we bring 2 million.’</p>
<p class="calibre3">“Riecke: ‘No.’</p>
<p class="calibre3">“Reich Marshal Göring: ‘A million and a half then.’</p>
<p class="calibre3">“Riecke: ‘Yes.’</p>
<p class="calibre3">“Reich Marshal Göring: ‘All right.’ ”</p>
</div>
<p class="pindent">The discussion went on in the same way. Göring’s speech ends
with the following sentence:</p>
<div class="blockquote">
<p class="calibre3">“ ‘Gentlemen, I would just like to say one thing more. I have
a very great deal to do and a very great deal of responsibility.
I have no time to read letters and memoranda informing
<span id="Page_51" title="51"></span>
me that you cannot supply my requirements. I have only
time to ascertain from time to time through short reports
from Backe whether the commitments are being fulfilled. If
not, then we shall have to meet on a different level.’ ”</p>
</div>
<p class="pindent">As Your Honors have heard, besides Göring this conference was
attended by the Defendants Rosenberg, Sauckel, Seyss-Inquart,
Frank, Funk, and others. As you have heard, Göring finished his
speech with a direct threat against the participants in this conference,
by saying that “we shall have to meet on a different level.”
This threat came true. The matter has, in every sense of the term,
been met on a different level—from the level of the dock.</p>
<p class="pindent">Thus the whole volume of evidence submitted establishes beyond
all doubt:</p>
<p class="pindent">1. That simultaneously with their well-laid preparations for the
military invasion of Czechoslovakia, Poland, Yugoslavia, Greece,
and the U.S.S.R., the criminal Hitlerite Government and the
Supreme Command of the German Armed Forces worked out a plan
for the mass plunder and spoliation of private, public, and state-owned
property in the territories belonging to these countries.</p>
<p class="pindent">2. That having worked out this criminal plan, the conspirators
carried out all the preliminary measures necessary for its execution
by training special bodies of officers and officials for the despoliation
of the territories they meant to seize by preparing and issuing
special instructions, reference books, and orders for this purpose,
and by creating a special and very complicated organization of all
sorts of “economic inspectorates,” “detachments,” “groups,” “joint
stock companies,” “plenipotentiaries,” <span class="it1">et cetera</span>, and by calling in
a large number of specialists in different branches, military experts
on agriculture, agricultural leaders, economic spies, <span class="it1">et cetera</span>.</p>
<p class="pindent">3. That in accordance with this long-prepared plan, they subsequently
plundered and despoiled private, public, and State
property in the occupied territories and also robbed the peaceful
population of these territories, having recourse to atrocities, violence,
and arbitrary practices of the most appalling nature.</p>
<p class="pindent">4. That in order to make the soldiers and the officers of the
German Army “economically interested” in the war, the conspirators
not only failed to prosecute cases of marauding and
robbery committed, by German soldiers and officers, but even
encouraged these crimes and incited their men to commit wholesale
looting.</p>
<p class="pindent">5. That by the commission of all these crimes the conspirators
caused enormous economic damage to the people of the occupied
territories, exposing them to starvation and suffering, and that they
profited by their criminal activities for the personal gain and
enrichment of themselves and their adherents.
<span id="Page_52" title="52"></span></p>
<p class="pindent">6. That having thus planned, prepared, and initiated wars of
aggression against the freedom-loving nations, the conspirators
aimed at the predatory despoliation of these nations and thereafter
achieved these criminal ends by means of equally criminal and
predatory methods.</p>
<p class="pindent">On the strength of the above, the defendants have consciously
and deliberately violated Article 50 of the Hague Convention of
1907, the laws and customs of war, the general principles of criminal
law accepted by the penal codes of all civilized nations, as well as
the national law of those countries in which these crimes were
committed.</p>
<p class="pindent">For these criminal acts, Your Honors, each and all of which are
covered by Article 6(b) of the Charter of the International Military
Tribunal, all the defendants must be found guilty; all of them
without exception must be held responsible both individually and
as members of the conspiracy.</p>
<p class="pindent">May it please Your Honors, the documents which I have presented
to the Tribunal and which I have read into the record are silent
witnesses to the crimes organized and committed by the defendants.</p>
<p class="pindent">But the conscience of the Judges will hear the testimony of
these silent witnesses, who relate truthfully the story of the
arbitrary practices and crimes of the Hitlerite brigands and the
boundless sufferings of their innumerable victims.</p>
<p class="pindent">THE PRESIDENT: The Tribunal will adjourn.</p>
<p class="line14">[<span class="it1">The Tribunal adjourned until 21 February 1946 at 1000 hours.</span>]</p>
<div class="calibre2"><span id="Page_53" title="53"></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?9d65b30e